import { render } from "./BusinessView.vue?vue&type=template&id=35ebd6f0&scoped=true&ts=true&lang=pug"
import script from "./BusinessView.vue?vue&type=script&lang=ts"
export * from "./BusinessView.vue?vue&type=script&lang=ts"

import "./BusinessView.vue?vue&type=style&index=0&id=35ebd6f0&lang=scss&scoped=true"

import exportComponent from "/Users/danielwu/Documents/bearathome/bat-project/bat-org-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ebd6f0"]])

export default __exports__